import { Trans } from 'react-i18next';
import { BodyText, Link } from '@gaiads/telia-react-component-library';

import { EMAIL_TITLE, EMAIL_TO, PHONE_NUMBER_TITLE, PHONE_NUMBER_TO, SameTabLinkAdapter } from '@cdaas/reusable-components-daas';

export const renderContactSupportText = (i18nKey: string) => {
  return (
    <BodyText>
      <Trans
        i18nKey={i18nKey}
        values={{ emailLink: EMAIL_TITLE, phoneLink: PHONE_NUMBER_TITLE }}
        components={{
          a1: (
            <Link color="purple500" to={EMAIL_TO} linkAdapter={SameTabLinkAdapter}>
              {EMAIL_TITLE}
            </Link>
          ),
          a2: (
            <Link color="purple500" to={PHONE_NUMBER_TO} linkAdapter={SameTabLinkAdapter}>
              {PHONE_NUMBER_TITLE}
            </Link>
          ),
        }}
      ></Trans>
    </BodyText>
  );
};
